<template lang="pug">
  table(
    v-sortable=`{
      handler: 'tr',
      callback: onSorted,
      container: 'tbody'
    }`
  )
    tbody
      template(v-for='item in items')
        template(v-if='item.children')
          s-table-tree(:items='item.children')
        tr
          td {{ item.name }}
</template>

<script>
export default {
  props: ['items'],
  methods: {
    onSorted() {}
  }
}
</script>
